var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
import TextField from "onnit-ui/lib/form/textfield/TextField";
import Icon from "onnit-ui/lib/icon/Icon";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
var PasswordField = function (props) {
    var _a = useState(true), isMasked = _a[0], setIsMasked = _a[1];
    var type = isMasked ? "password" : "text";
    var inputRef = props.inputRef, onChange = props.onChange, value = props.value, rest = __rest(props, ["inputRef", "onChange", "value"]);
    var icon = value.length ? (React.createElement(Icon, { color: "grays.4", icon: type === "password" ? IoMdEyeOff : IoMdEye, onClick: function () { return setIsMasked(!isMasked); } })) : null;
    return (React.createElement(TextField, __assign({ ref: inputRef, type: type, name: "password", value: value, onChange: onChange, autoComplete: "password", icon: icon }, rest)));
};
PasswordField.defaultProps = {
    label: "Password",
};
export default PasswordField;
//# sourceMappingURL=PasswordField.js.map